import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const QuickLinksEmpty = observer(() => {
  const { usersStore } = useEntitiesContext()

  return (
    <Typography className={styles.empty} ariaLabel={'Quick links empty'} variant='body-sm-regular'>
      {!!usersStore.user?.isViewOnlyRole ? (
        <>No quick links.</>
      ) : (
        <>
          Click on Manage links to add quick
          <br />
          links for your team.
        </>
      )}
    </Typography>
  )
})
